import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  toast: {
    width: "100%",
    maxWidth: "700px",
    position: "relative",
    transform: "none",
    alignItems: "flex-end",
    left: "auto",
    right: "auto",
    bottom: "auto",
    marginTop: theme.spacing(2),
    "& .MuiAlert-root": {
      flex: 1,
    },
  },
}));
